import { Response } from '@marketplace-web/shared/api-client'

import { GetLabelOptionsResp } from '../../types/label-options'
import { transformLabelOptions } from '../label-options'

export const transformLabelOptionsResponse = (response: Response<GetLabelOptionsResp>) =>
  transformLabelOptions(response.label_options)
